import type { ApiErrorBody } from "../../shared/contracts";

export class ApiError extends Error {
  constructor(
    public readonly status: number,
    public readonly code: string,
    message: string,
    public readonly fields?: Record<string, string>
  ) {
    super(message);
    this.name = "ApiError";
  }
}

export async function api<T>(path: string, init: RequestInit = {}): Promise<T> {
  const headers = new Headers(init.headers);
  if (init.body && !(init.body instanceof FormData) && !headers.has("Content-Type")) {
    headers.set("Content-Type", "application/json");
  }
  const response = await fetch(`/api${path}`, { ...init, headers, credentials: "same-origin" });
  if (response.status === 204) return undefined as T;
  const body = await response.json().catch(() => null) as T | ApiErrorBody | null;
  if (!response.ok) {
    const errorBody = body as ApiErrorBody | null;
    if (response.status === 401) {
      window.dispatchEvent(new Event(errorBody?.error.code === "SESSION_REPLACED"
        ? "share-moments:session-replaced"
        : "share-moments:unauthorized"));
    }
    if (errorBody?.error.code === "SETUP_REQUIRED") window.dispatchEvent(new Event("share-moments:setup-required"));
    throw new ApiError(
      response.status,
      errorBody?.error.code ?? "REQUEST_FAILED",
      errorBody?.error.message ?? "请求失败，请稍后重试",
      errorBody?.error.fields
    );
  }
  return body as T;
}

export function jsonBody(value: unknown): Pick<RequestInit, "body"> {
  return { body: JSON.stringify(value) };
}
